import { render, staticRenderFns } from "./crm-work-history.vue?vue&type=template&id=3d0a531c&"
import script from "./crm-work-history.vue?vue&type=script&lang=js&"
export * from "./crm-work-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports